module.exports = __webpack_public_path__ + "img/ep-R-dosis.c4c4d51e.jpg";